Drupal.behaviors.lastGuideB5StepSlider = {
  attach: function (context, settings) {
    jQuery('.slider').each(function () {
      const sliderLength = jQuery(this).find('.gallery').find('a').length;
      const icons = jQuery(this).closest('.field__item').find('.slider-3-bottom');
      if (sliderLength < 1) {
        jQuery(this, context).hide();
        jQuery(icons, context).removeClass('mt-4');
      }

      if (sliderLength > 3) {
        if (!jQuery(this).hasClass('slick-initialized')) {
          jQuery(this, context).slick({
            autoplay: false,
            arrows: true,
            centerMode: false,
            cssEase: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
          });
        }
      } else {
        jQuery(this, context).addClass("slide-down-3");
      }
    });

    // FancyBox
    jQuery('.step-gallery-container', context).each(function () {
      const group = jQuery(this).attr('data-image-group-name');
      jQuery(this).find('.gallery a').attr('data-fancybox', group);
    });
  },
};
